module.exports = __webpack_public_path__ + "static/media/Ring.1ff36930.png";